<div class="add-material-dialog">
  <div class="loading-shaded-spinner" *ngIf="showLoader">
    <mat-spinner></mat-spinner>
  </div>

  <mat-dialog-content>
    <h1 mat-dialog-title>Upload Material</h1>
    <mat-horizontal-stepper [linear]="true" #stepper id="stepper">

      <!--********************** Mat Step 1 ************************-->
      <mat-step label="Information" [completed]="infoCompleted1">
        <form>
          <div class="form-row full-width">
            <mat-form-field class="full-width material-step-field" appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput type="text" class="inputValidationField" [(ngModel)]="materialFormData.title" name="title" (change)="checkInformation()" required>
              <mat-error *ngIf="!materialFormData?.title">Please enter a title.</mat-error>
            </mat-form-field>
          </div>

          <div class="form-row full-width">
            <div *ngFor="let _category of currentCategories; let i=index" class='categories-wrapper'>
              <div class="group-container">
                <mat-form-field class="material-step-field cat-select-field" appearance="outline">
                  <mat-label>Category</mat-label>
                  <mat-select name="category" (selectionChange)="checkForSubs($event.value, i)" required>
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let category of materialCategories" [value]="category">
                      {{category.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field *ngIf="currentCategories[i].availableSubCategories && currentCategories[i].availableSubCategories.length" class="material-step-field sub-cat-select-field" appearance="outline">
                  <mat-label>Sub-Category</mat-label>
                  <mat-select name="subCategorySelect" (selectionChange)="subCatChanged($event.value, i)" required>
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let _subCategory of currentCategories[i].availableSubCategories" [value]="_subCategory.name">
                      {{_subCategory.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="remove-icon-container col-12">
                  <mat-icon matSuffix class="delete-icon" (click)="removeGroup(_category)">close</mat-icon>
                </div>
              </div>
            </div>

            <button mat-raised-button class="add-sub-btn" color="primary" (click)="addCategory()">
              <i class="material-icons">add</i>
              <span>Category</span>
            </button>
          </div>

          <div class="mat-error errorMessage" *ngIf="hasError?.messages?.length">
            <div *ngFor="let _message of hasError.messages">{{ _message }}</div>
          </div>

          <div class="btnContainer">
            <div class="left-btns">
              <button mat-raised-button color="primary" matStepperNext (click)="checkInformation()">Next</button>
            </div>

            <div class="right-btn">
              <button mat-raised-button mat-dialog-close (click)="unconfirmCreate()">Cancel</button>
            </div>
          </div>
        </form>
      </mat-step>

      <!--********************** Mat Step 2 ************************-->
      <mat-step label="Description" [completed]="infoCompleted2">
        <form>
          <ng-template matStepLabel>Description</ng-template>
          <div class="form-row">
            <mat-form-field class="full-width material-step-field" appearance="outline">
              <mat-label>Description</mat-label>
              <textarea matInput 
                type="text" 
                id="create_description_area" 
                class="description-area inputValidationField" 
                [(ngModel)]="materialFormData.description" 
                name="description" 
                (keyup)="checkDescription()" 
                (keydown)="onDescriptionKeydown($event)" 
                placeholder="Describe your product and how it can be helpful to another educator." 
                required>
              </textarea>
              <mat-error *ngIf="!materialFormData?.description">Please enter a description.</mat-error>
            </mat-form-field>

            <div class="letterCount">
              <p><span class="count-title">Total word Count: </span> <span id="display_count">{{ currentWordCount }}</span> words.</p> 
              <p><span class="count-title">Words left: </span> <span id="word_left">{{ wordsLeft }}</span></p>
            </div>
          </div>

          <div class="btnContainer">
            <div class="left-btns">
              <button mat-raised-button class="back-btn" color="accent" matStepperPrevious>Back</button>
              <button mat-raised-button class="next-btn" color="primary" matStepperNext>Next</button>
            </div>

            <div class="right-btn">
              <button mat-raised-button mat-dialog-close (click)="unconfirmCreate()">Cancel</button>
            </div>
          </div>
        </form>
      </mat-step>

      <!--********************** Mat Step 3 ************************-->
      <mat-step [stepControl]="thirdFormGroup">
        <form #fileForm [formGroup]="thirdFormGroup" ngNoForm name="addMaterialForm" enctype="multipart/form-data">
          <ng-template matStepLabel>Files</ng-template>
          <div class="form-row">

            <!-- File Drag n Drop -->
            <div class="drag-container">
              <div class="dnd" [ngClass]="{'no-error':tempMainFileName, 'has-error':!tempMainFileName}">
                <input #file 
                  id="fileInput" 
                  type="file"  
                  name="myfile" 
                  accept="image/jpeg, image/jpg, image/gif, image/png, application/pdf, video/mp4, video/x-m4v, video/*" 
                  (change)="onFilesAdded($event)">

                <div class="dnd-text-wrapper">
                  <p>Material File</p>
                  <p>Select file or drag and drop</p>
                </div>
              </div>

              <mat-error class="image-error" *ngIf="!tempMainFileName">
                  Please select an file to upload.
              </mat-error>
            </div>

            <div class="file-preview" *ngIf="fileToPreview">
              <video *ngIf="materialFormData?.fileType === 'Video'" class="attachmentVideo" [src]="fileToPreview" controls></video>

              <div class="doc-container">
                <img *ngIf="materialFormData?.fileType !== 'Video'" [src]="fileToPreview" alt="Preview" />
              </div>
            </div>

            <!-- Upload choices and thumbnail container -->
            <div class="form-row upload-option-wrapper">
              <mat-radio-group class="auto-group" [ngModelOptions]="{standalone: true}" [(ngModel)]="uploadValue" (change)="checkUploadThumbnailValue()">
                <mat-radio-button class="auto-choice" value="1">Auto generated thumbnails</mat-radio-button>

                <!-- Thumbnails row -->
                <div class="thumbnail-section-wrapper" [ngClass]="{'no-error': materialFormData?.defaultImage, 'has-error': !materialFormData?.defaultImage}">
                  <!-- Placeholder text options -->
                  <div *ngIf="!fileToPreview && uploadValue === '1' && coverImages.length <= 0" class="thumbnail-placeholder">
                    <p class="placeholder-text">Thumbnails will generate once you upload your material file.</p>
                  </div>

                  <div *ngIf="uploadValue === '2' && ['PDF','Video'].includes(materialFormData?.fileType) && coverImages.length <= 0" class="thumbnail-placeholder">
                    <p class="placeholder-text">Please choose additional image file(s) to be displayed on materials page for the cover image(s).</p>
                  </div>

                  <div *ngIf="coverImages?.length > 0" class="coverImage-list-wrapper">
                    <div class="coverImage-item-wrapper" *ngFor="let _img of coverImages" [ngClass]="{ 'selected': _img === fileToPreview }" (click)="imageSelected(_img)">
                      <img class="coverImage-item-img" [src]="_img" alt="Thumbnail" />
                    </div>
                  </div>
                </div>

                <mat-radio-button *ngIf="['PDF','Video'].includes(materialFormData?.fileType)" class="now-choice" value="2">Upload own thumbnails now</mat-radio-button>

                <div *ngIf="uploadValue === '2'" class="newCoverImage">
                  <input type="file" #ownCoverImage id="ownCoverImage" name="ownCoverImage" accept="image/jpeg, image/gif, image/png" (change)="onOwnCoverImageUpload($event)" multiple>
                </div>
              </mat-radio-group>
            </div>

            <!-- Hidden inputs to hold values for step 3 to allow stepper to continue. -->
            <div class="form-row hidden-row">
              <mat-form-field class="hidden-field material-step-field">
                <input matInput type="text" id="fileImageToPass-input" class="inputValidationField" formControlName="fileImageToPassCtrl" (keyup)="checkFormValidation()" (change)="checkFormValidation()" required>
              </mat-form-field>

              <mat-form-field class="hidden-field material-step-field">
                <input matInput type="text" id="filePdfToPass-input" class="inputValidationField" formControlName="otherFileToPassCtrl" (keyup)="checkFormValidation()" (change)="checkFormValidation()" required>
              </mat-form-field>
            </div>

          </div>

          <div class="btnContainer">
            <div class="left-btns">
              <button mat-raised-button class="back-btn" color="accent" matStepperPrevious>Back</button>
              <button mat-raised-button class="next-btn" color="primary" matStepperNext>Next</button>
            </div>

            <div class="right-btn">
              <button mat-raised-button mat-dialog-close (click)="unconfirmCreate()">Cancel</button>
            </div>
          </div>
        </form>
      </mat-step>

      <!--********************** Mat Step 4 ************************-->
      <!-- <mat-step [stepControl]="fourthFormGroup">
        <form [formGroup]="fourthFormGroup">
          <ng-template matStepLabel>Copyright</ng-template>
          <div class="form-row copyright-row">
            <label class="copyright-label">Copyright:</label>
            <p class="copyright-text">
              Intellectual Property Rights: By uploading the selected material I certify that I have read and
              agree to the Speaking of Speech <a class="toa-link" (click)="showTermsDialog()">terms of service</a> and that the selected material does not
              infringe the copyrights, trademark rights, or any other rights of any third party, and:
            </p>
            <mat-checkbox
              class="check-margin"
              name="agreementChecked"
              formControlName="copyrightCtrl"
              (change)="checkFormValidation()"
              [(indeterminate)]="indeterminate"
              [labelPosition]="labelPosition"
              required>
                I attest that this material I am about to post is an original work and it does not infringe upon
                the Intellectual Property rights of others.
            </mat-checkbox>

            <mat-error *ngIf="!checked">
                Please agree with the terms of service.
            </mat-error>
          </div>

          <div class="btnContainer">
            <div class="left-btns">
              <button mat-raised-button class="back-btn" color="accent" matStepperPrevious>Back</button>
              <button mat-raised-button class="next-btn" color="primary" matStepperNext>Next</button>
            </div>

            <div class="right-btn">
              <button mat-raised-button mat-dialog-close (click)="unconfirmCreate()">Cancel</button>
            </div>
          </div>
        </form>
      </mat-step> -->

      <!--********************** Mat Step 5 ************************-->
      <mat-step>
        <ng-template matStepLabel>Create</ng-template>
        <div class="success-message">
          <h5>You can now create this material!</h5>
        </div>
        <div class="done-buttons">
          <div class="left-btns">
            <button mat-raised-button class="back-btn" color="accent" matStepperPrevious>Back</button>
            <button mat-raised-button class="proceed-btn" color="primary" type="submit" (click)="saveMaterial()">Create</button>
          </div>
          <div class="right-btn">
            <button mat-raised-button mat-dialog-close (click)="unconfirmCreate()">Cancel</button>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-dialog-content>
</div>